const valuesSecEl = document.querySelector('.values-sec');

if (valuesSecEl) {
  const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            import('./gradient.component.js').then(({ Gradient }) => {
              const gradient = new Gradient();
              gradient.initGradient('#gradient-canvas-values');
            });

            obs.disconnect();
          }
        });
      },
      { threshold: 0.1 }
  );

  observer.observe(valuesSecEl);
}